"use client";

import { useSyncExternalStore } from "react";

const desktopSize = 1024;

// Single shared source of truth for the viewport width.
// All consumers subscribe to the same store, so `useSyncExternalStore`
// guarantees they read the same value in the same commit (no tearing).
// This prevents responsive components whose layout is split across several
// sub-components (e.g. Combobox Root/Trigger/Content) from momentarily
// disagreeing about mobile vs. desktop.
const subscribe = (callback: () => void) => {
  window.addEventListener("resize", callback);
  return () => window.removeEventListener("resize", callback);
};

const getSnapshot = () => window.innerWidth;

// Rendered on the server and during hydration. 0 keeps the previous
// mobile-first behavior (0 < size, 0 < desktopSize) and matches on both sides.
const getServerSnapshot = () => 0;

const useWindowWidth = () => useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

const useScreenSize = (size = desktopSize) => {
  const windowSize = useWindowWidth();
  return [windowSize >= size, windowSize];
};

export default useScreenSize;

export const useScreenSizeEffect = (size = desktopSize) => {
  const windowWidth = useWindowWidth();
  return windowWidth < size;
};
